import { Controller } from 'stimulus';

export default class extends Controller {
  static targets = ['percentage', 'progressBar'];
  static outlets = ['video-library'];

  videoLibraryOutletConnected(outlet) {
    if (!this._videoLibraryStatusChangedHandler) {
      this._videoLibraryStatusChangedHandler = () => {
        this.updateCourseProgressIndicator();
      };
    }

    outlet.element.addEventListener(
      'video-library:status-changed',
      this._videoLibraryStatusChangedHandler
    );

    this.updateCourseProgressIndicator();
  }

  videoLibraryOutletDisconnected(outlet) {
    if (this._videoLibraryStatusChangedHandler) {
      outlet.element.removeEventListener(
        'video-library:status-changed',
        this._videoLibraryStatusChangedHandler
      );
    }
  }

  updateCourseProgressIndicator() {
    const videos = this.videoLibraryOutlet?.videoTargets || [];
    const totalVideos = videos.length;
    const completedVideos = videos.filter((video) => video.dataset.completed === 'true');
    const courseProgress =
      totalVideos === 0 ? 0 : Math.ceil((completedVideos.length / videos.length) * 100);
    const courseProgressPercentage = `${courseProgress}%`;
    const indicatorColor = courseProgress === 100 ? '#8ed23d' : '#1c4c7a';

    this.percentageTarget.textContent = courseProgressPercentage;
    this.progressBarTarget.style.width = courseProgressPercentage;

    this.percentageTarget.style.color = indicatorColor;
    this.progressBarTarget.style.backgroundColor = indicatorColor;
  }
}
